<homey-page-title title="Login details"/>

<div class="text-center text-surface-500 mt-4">
  <p>Logged in as</p>
  <p>{{ email() }}</p>
</div>

@let socialLogin = loginMethod() === 'socials';
<p-button severity="secondary" styleClass="w-full mt-6" (onClick)="onChangePasswordClick()" [disabled]="socialLogin">
  Change password
</p-button>
@if (socialLogin) {
  <p class="text-surface-500 text-sm text-center mt-1">You logged via social login, password reset not available.</p>
}
